interface SectionTagProps {
  children: string;
  light?: boolean;
}

export function SectionTag({ children, light = false }: SectionTagProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] ${
        light ? "text-white/70" : "text-ink-soft"
      }`}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gradient-brand" />
      {children}
    </span>
  );
}
